import { render, staticRenderFns } from "./ContentShow.vue?vue&type=template&id=cd1563e8&scoped=true&"
import script from "./ContentShow.vue?vue&type=script&lang=js&"
export * from "./ContentShow.vue?vue&type=script&lang=js&"
import style0 from "./ContentShow.vue?vue&type=style&index=0&id=cd1563e8&scoped=true&lang=less&"
import style1 from "./ContentShow.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd1563e8",
  null
  
)

export default component.exports